import { useModal } from '@ebay/nice-modal-react'
import { useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'

import LoginModal from '../components/common/log-in-modal'
import DepositModal from '../components/wallet-management/deposit-modal'
import { decryptUser } from '../utils/user'
import useGeoCheck from './useGeoCheck'

function useContinue() {
  const logInModal = useModal(LoginModal)
  const depositModal = useModal(DepositModal)
  const { geoCheck } = useGeoCheck()
  const navigate = useNavigate()

  // Run once on mount. This used to depend on a URLSearchParams object created
  // on every render, so any root re-render (login completing, settings load,
  // window resize) re-ran the effect and re-opened the dismissed modal.
  // `?continue=...` is an entry-only marketing param, so mount-time is enough.
  useEffect(() => {
    const continueTo = new URLSearchParams(window.location.search).get(
      'continue',
    )
    const user = decryptUser()

    if (!continueTo) return
    if (!user) {
      // Preserve the deposit intent across the login: after a successful
      // login the login modal reloads to this URL, remounting root so this
      // effect re-fires and opens the deposit modal for the now-authed user.
      if (continueTo === 'deposit') {
        navigate({
          search: prev => ({ ...prev, redirectUrl: '/?continue=deposit' }),
        })
      }
      geoCheck(logInModal.show)
      return
    }

    if (continueTo === 'deposit') {
      depositModal.show()
    }
  }, [])
}

export default useContinue
